import { SeedPlusOutlineIcon } from './SeedPlusOutlineIcon';

/**
 * author: Jeff Anders
 * id 01263D30-0B40-46AA-A17B-31EABA51DD48
 * name seed-plus-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seed-plus-outline.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const SeedAddOutlineIcon = SeedPlusOutlineIcon;
export default SeedAddOutlineIcon